<template>
  <div class="table-page-wrapper">
    <div v-show="searchStatus" class="search-wrapper">
      <!-- <el-select v-model="tableParams.isAccount" clearable placeholder="是否结算"  style="margin-right:15px">
          <el-option value="0" label="已结算"></el-option>
          <el-option value="1" label="未结算"></el-option>
      </el-select>
      <el-select v-model="tableParams.isTicket" clearable placeholder="开票状态"  style="margin-right: 15px">
          <el-option value="0" label="已开票"></el-option>
          <el-option value="1" label="未开票"></el-option>
      </el-select> -->
      <el-date-picker
        v-model="date"
        @change="changeDate"
        style="margin-right: 15px;"
        type="monthrange"
        range-separator="至"
        start-placeholder="开始月份"
        end-placeholder="结束月份"
        :editable="false"
      >
      </el-date-picker>
      <el-select v-model="tableParams.settleWay" clearable placeholder="计费方式"  style="margin-right:15px">
        <el-option value="1" label="CPM"></el-option>
        <el-option value="2" label="CPD"></el-option>
        <el-option value="3" label="CPA"></el-option>
      </el-select>
      <el-button @click="toQuery" type="primary" >搜索</el-button>
    </div>

    <div class="table-wrapper">
      <table-column
        @search="searchColumn"
        @refresh="toQuery"
        @change="changeColumn"
        :column="columns"
        style="padding-bottom: 10px;">
        <ul v-if="isProd" class="bill-desc" style="font-size: 12px;color: #f17f36">
          <li>每月20号系统自动生成上月结算单，如数据核对无误，请尽快安排开票。如对应付金额有异议，请及时联系运营。</li>
          <li>上传发票：选取文件后点击上传到服务器，如有邮寄请填写快递单号。每月25--30日根据到票情况按账期付款（到票后60天内）。</li>
          <li>邮寄地址：广州市番禺区南村镇汉溪大道东388号4栋1505。李伟 收 17753133345</li>
        </ul>
        <ul v-else class="bill-desc" style="font-size: 12px;color: red">
          <li>每月20号系统自动生成上月结算单，如数据核对无误，请尽快安排开票。如对应付金额有异议，请及时联系运营。</li>
          <li>上传发票：选取文件后点击上传到服务器，如有邮寄请填写快递单号。每月25--30日根据到票情况按账期付款（到票后60天内）。</li>
        </ul>
      </table-column>

      <el-table
        :data="tableData"
        height="80vh"
        :header-cell-style="{background:'#fafafa'}"
        highlight-current-row
        :summary-method="tableSummary"
        show-summary
        size="small"
        ref="table"
        class="js-table"
        style="width: 100%">
        <el-table-column
          v-for="(v, i) in checkColumns"
          :prop="v.field"
          :label="v.title"
          :width="v.width"
          :min-width="v.minWidth"
          :key="i"
          align="center">
          <template v-slot="scope">
            <div v-if="v.field === 'ticketUrls'">
              <el-popover
                placement="top-start"
                width="210"
                trigger="click"
                ref="popover">
                <template #reference>
                  <div>
                    <el-button size="mini" type="primary" @click="movefileList">上传发票</el-button>
                  </div>
                </template>
                <div v-for="(v, i) in scope.row.ticketUrls" :key="i">
                  <img :src="$imgURL+v" style="width: 200px;padding:5px"
                       alt="">
                </div>
                <el-upload
                  class="upload-demo"
                  ref="upload"
                  :action="$baseURL + 'common/upload/image'"
                  :headers="header"
                  :multiple="true"
                  :file-list="fileList"
                  :on-remove="onRemove"
                  accept="image/*,.zip"
                  :on-success="(value) => onSuccess(scope.row, value)"
                >
                  <template #trigger>
                    <el-button size="small" type="primary">选取文件</el-button>
                  </template>
                  <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">（必点）上传到服务器
                  </el-button>
                </el-upload>
              </el-popover>
            </div>
            <div v-else-if="v.field === 'isAccount'">
              <el-button type="primary" style="width:80px" size="mini"
                         :disabled="!(scope.row[v.field]==3&&scope.row.ticketUrls)" @click="handleSetting(scope.row)">
                {{ accountMap[scope.row[v.field]] || '-' }}
              </el-button>
            </div>
            <div v-else-if="v.field === 'odd'">
              <div v-if="scope.row[v.field]">
                <el-tag  @click="upOdd(scope.row)">{{ scope.row[v.field] }}</el-tag>
              </div>
              <div v-else>
                <el-button size="mini" type="primary" @click="upOdd(scope.row)">新增</el-button>
              </div>
            </div>
            <span v-else>{{ scope.row[v.field] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="下载对账单" fixed="right" align="center" width="100">
          <template v-slot="scope" align="center">
            <el-button
              @click="downExcel('/reportCollect/media/collect/list/xlsx', '明细下载',{'reportId':scope.row.reportId})"
              type="warning"
              size="mini"
              style="margin-left: 10px;">
              下载
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :total="pagination.total"
        :pager-count="6"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :page-sizes="[10, 30, 60]"
        background
        layout="total,sizes,prev,pager,next"
        style="margin-top: 40px;"/>
    </div>

    <el-dialog
      v-model="dialogStatus"
      @close="auditClose"
      title="快递单号"
      :width="500"
      align="center"
      append-to-body>
      <el-input v-model="oddData" placeholder="请输入快递单号"></el-input>
      <div style="margin: 20px 0;text-align: right;">
        <el-button @click="auditClose" >关闭</el-button>
        <el-button @click="audit" type="primary" >保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { formatDate, SIMPLE_MONTH_PATTERN } from '@/util/format'
import { downExcelMixin } from '@/mixins/downExcel'
import initTableMixin from '@/mixins/initTable'
import BaseDatePicker from '@/components/BaseDatePicker'
import TableColumn from '@/components/TableColumn'
import { addInvoice, upDataOdd } from '@/api/manage/account/bill'
import { auditing } from '@/api/manage/account/monthly'

export default {
  name: 'Manage/account/bill',
  components: {
    BaseDatePicker,
    TableColumn
  },
  mixins: [initTableMixin, downExcelMixin],
  data () {
    return {
      columns: [
        {
          field: 'dateCreated',
          title: '创建时间'
        },
        {
          field: 'reportDate',
          title: '月份'
        },
        {
          field: 'alreadyExpenses',
          title: '结算金额'
        },
        {
          field: 'awaitExpenses',
          title: '待结算金额'
        },
        {
          field: 'settleWay',
          title: '计费方式'
        },
        {
          field: 'ticketUrls',
          title: '上传发票'
        },
        {
          field: 'odd',
          title: '快递单号'
        },
        {
          field: 'isAccount',
          title: '结算状态'
        },
        {
          field: 'remark',
          title: '说明'
        }
      ],
      accountMap: {
        3: '申请提现',
        2: '审核中',
        1: '不通过',
        0: '已付款'
      },
      ticketMap: {
        1: '未开票',
        0: '已开票'
      },
      dialogStatus: false,
      statusData: {},
      date: [new Date(), new Date()],
      header: {},
      fileList: [],
      urlData: {},
      oddData: undefined,
      isProd: false,
      params: {},
    }
  },
  created () {
    this.header = {
      Authorization: 'Bearer ' + this.access_token,
      responseType: 'blob'
    }
    this.date[0].setMonth(new Date().getMonth(), 0)
    this.date[1].setMonth(new Date().getMonth(), 0)
    this.changeDate(this.date)
    if (process.env.NODE_ENV === 'development') {
      this.isProd = false
    } else {
      this.isProd = process.env.NODE_ENV !== 'production'
    }
  },
  computed: {
    ...mapGetters([
      'access_token'
    ])
  },
  mounted () {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    beforeInit () {
      this.tableUrl = '/reportCollect/media/collect/list'
      return true
    },
    afterInit (res) {
      this.tableData = res.data.getMediaReportCollectListRes.records
    },
    changeDate (date) {
      this.tableParams.startTime = date[0] ? formatDate(date[0], SIMPLE_MONTH_PATTERN) : date[0]
      this.tableParams.endTime = date[1] ? formatDate(date[1], SIMPLE_MONTH_PATTERN) : date[1]
    },
    // handleAccountChange (state,row) {
    //     if(!row.reportId){
    //         return
    //     }
    //     this.dialogStatus=true;
    //     this.statusData = {
    //         reportId: row.reportId,
    //         isTicket: state
    //     }
    //     setStatus(this.statusData).then(res => {
    //     if (res.code === 200) {
    //       this.$message.success('修改开票状态成功')
    //       this.dialogStatus=false;
    //     }
    //     }).catch(() => {
    //         this.$message.error('修改开票状态失败')
    //         this.dialogStatus=false;
    //         for (let i = 0; i < this.tableData.length; i++) {
    //         if (this.tableData[i].reportId === data[0].reportId) {
    //             this.tableData[i].reportId = this.tableData[i].reportId ? 0 : 1
    //             return
    //         }
    //         }
    //     })
    // },
    //  beforeAvatarUpload (file) {
    //      const isIMG =
    //         file.type === 'image/jpg' ||
    //         file.type === 'image/jpeg' ||
    //         file.type === 'image/png'
    //     let fileName = file.name
    //     let pos = fileName.lastIndexOf('.')
    //     let lastName = fileName.substring(pos, fileName.length)
    //     if (lastName.toLowerCase() !== '.zip' &&!isIMG) {
    //         this.$message.error('上传发票只能上传一张且为jpg、jpeg、png格式!多张图片请压缩后上传zip格式文件')
    //         return
    //     }
    //  },
    // onSuccess(row,res){
    //     if (res.code === 200) {
    //         let urlData={
    //             reportId:row.reportId,
    //             fileUrl:res.data[0]
    //         }
    //     addInvoice(urlData).then(res=>{
    //         if(res.code==200){
    //             this.$message.success('上传发票成功')
    //         }
    //         this.init()
    //     }).catch(()=>{
    //         this.$message.error('上传发票失败')
    //         this.init()
    //     })
    //   }else{
    //     this.$message.error(res.msg)
    //     this.init()
    //   }
    // },
    onSuccess (row, res) {
      if (res.code === 200) {
        this.urlData.reportId = row.reportId
        this.urlData.fileUrl = (this.urlData.fileUrl ? this.urlData.fileUrl + ',' : '') + res.data[0]
      } else {
        this.$message.error(res.msg)
        this.init()
      }
    },
    movefileList () {
      this.$refs.upload.clearFiles()
      this.urlData = {}
      // this.fileList=[];
    },
    onRemove (file, fileList) {
      let list = ''
      fileList.forEach(item => {
        list = (list ? list + ',' : '') + item.response.data[0]
      })
      this.urlData.fileUrl = list
    },
    submitUpload () {
      addInvoice(this.urlData).then(res => {
        if (res.code === 200) {
          this.$message.success('上传发票成功')
        }
        this.init()
      }).catch(() => {
        this.$message.error('上传发票失败')
        this.init()
      })
    },
    handleSetting (row) {
      const auditData = {
        reportId: row.reportId,
        isAccount: 2
      }
      auditing(auditData).then(res => {
        if (res.code === 200) {
          this.init()
        }
      }).catch(() => {
        this.$message.error('结算状态失败')
      })
    },
    upOdd (row) {
      this.dialogStatus = true
      this.params.reportId = row.reportId
    },
    audit () {
      this.params.odd = this.oddData
      upDataOdd(this.params).finally(() => {
        this.auditClose()
        this.init()
      })
    },
    auditClose () {
      this.dialogStatus = false
      this.oddData = undefined
      this.params = {}
    },
    tableSummary () {
      const arr = ['alreadyExpenses', 'awaitExpenses']
      const data = this.tableData
      const checklists = this.checkColumns.map(item => {
        return item.field
      })
      const out = []
      for (let i = 0; i < checklists.length; i++) {
        if (i === 0) {
          out[i] = '合计'
        } else {
          out[i] = arr.indexOf(checklists[i]) > -1 ? data.reduce((total, item) => { return total + Number(item[checklists[i]]) }, 0) : '-'
        }
      }
      return out
    }
  }
}
</script>

<style lang="scss" scoped>
.search-wrapper {
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;

  & > * {
    margin-right: 15px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }

  & > .el-select, & > .el-input {
    width: 220px;
  }
}

.table-wrapper {
  padding: 15px;
  background: #ffffff;

  .table__operation {
    padding-bottom: 10px;
  }
}

.el-table::before {
  height: 0;
}

.el-pagination {
  text-align: right;
}

.form-label {
  display: block;
  line-height: 20px;
}

.form-item__label {
  line-height: 20px;
}
</style>
